<template>
  <v-menu
      offset-y tile depressed
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          dark
          depressed
          tile
          large
          text
          v-on="on"
          v-bind="attrs"
          :aria-label="$t(`app.menu.ariaLabel.button`)"
      >
        {{ isMobile ? '' : userName }}
        <v-icon :class="chevronClass(attrs)">mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-list
        tile
        dark
        color="black"
        role="navigation"
        :aria-label="$t('app.menu.ariaLabel.content')"
    >
      <v-subheader v-if="isMobile">
        {{ userName }}
      </v-subheader>
      <v-list-item @click="disconnect">
        <v-list-item-icon><v-icon>mdi-power</v-icon></v-list-item-icon>
        <v-list-item-title>{{ $t('app.button.disconnect') }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="toSettings">
        <v-list-item-icon><v-icon>mdi-cog</v-icon></v-list-item-icon>
        <v-list-item-title>{{ $t('settings.navLink') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {mapGetters} from 'vuex'
import ResponsiveMixin from '@/components/common/ResponsiveMixin'

export default {
  name: "Disconnection",
  mixins: [ResponsiveMixin],
  computed: {
    ...mapGetters(['userName', 'logoutUrl']),
  },
  methods: {
    disconnect() {
      window.location.replace(this.logoutUrl)
    },
    chevronClass(attrs) {
      return attrs["aria-expanded"] === "true" ? 'open' : ''
    },
    toSettings() {
      if (this.$route.name !== 'settings') {
        this.$router.push({name: 'settings'})
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.v-btn {
  .v-icon {
    transform: rotate(0deg);
    transition: transform 300ms linear;
    &.open {
      transform: rotate(180deg);
      transition: transform 300ms linear;
    }
  }
}

.v-menu__content{
  border-radius: 0;

  .v-list::v-deep{

    border-radius: 0;
    .v-subheader{
      justify-content: center;
    }

    .v-list-item__icon {
      margin-right: 10px;
    }
  }
}
</style>
